import axios from "axios";
import env from "@/env";
import router from "@/router";
import {notifyError} from "@/components/composables/messages";
import store from "@/state/store";

const http = axios.create({
    baseURL: env.api,
});

// Função que retorna o token atualizado
function getToken() {
    return localStorage.getItem('token');
}

// Adicionando um interceptador de requisição ao Axios
http.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Adicionando um interceptador de resposta para lidar com erros
http.interceptors.response.use(
    (response) => {
        // Se a resposta for bem-sucedida, simplesmente a retorne
        return response;
    },
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 402)) {
            store.commit('api/endProcessing');
            // Código 401 - Unauthorized
            notifyError('Não autorizado!');
            localStorage.removeItem('token'); // Remove o token do localStorage
            if (router.name !== 'login') router.push('/login'); // Redireciona o usuário para a página de login
        } else {
            if (error.response.status === 403) {
                notifyError('Acesso negado!');
            }
            // Retorna a Promise rejeitada para que o erro possa ser tratado caso necessário
            return Promise.reject(error);
        }
    }
);

export default http;
